import React from "react";
import classnames from "classnames";
import MultiCustomCreatableSelection from "@components/Common/MultiCustomCreatableSelection";
import MultiCustomSelect from "@components/Common/MultiCustomSelect";
import {
    CrossIcon,
    StyledSelectInput,
    StyledTextInput,
} from "@aureskonnect/react-ui";
import { CustomCardFooter } from "@components/Common/CustomCardStyled";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { useTranslation } from "react-i18next";
import { formatCreateLabelModeOfSale, translatedSaleMethod } from "./hooks";
import { t } from "i18next";

export function FormHeader({
    title,
    isEdited,
    setIsConsult,
    setIsActionsClicked,
    setActions,
    setDataSale,
    setIsEdited,
    clearMultiCustomSelectionData,
    clearData,
    setInputSaleMode,
    setDataIsUpdated,
    setModalState,
}: any) {
    return (
        <React.Fragment>
            <h5
                className={classnames("pt-3", {
                    mdv_txt_FReditSalesMode: title !== "Add a sales method",
                    mdv_txt_FRtitleFormModeOfSale:
                        title === "Add a sales method",
                })}
            >
                {title}
            </h5>
            <CrossIcon
                className="mdv_icn_FRcloseForm"
                height={13}
                width={13}
                onClick={() => {
                    setIsConsult(false);
                    if (isEdited === true) {
                        setIsActionsClicked((prev: any) => !prev);
                        setActions(() => {
                            setDataSale([]);
                            setModalState((prev: any) => ({
                                ...prev,
                                isAddModeOfSaleClicked: false,
                            }));
                            setIsEdited(false);
                            clearMultiCustomSelectionData();
                            clearData();
                            setInputSaleMode(false);
                            setDataIsUpdated(true);
                        });
                    } else {
                        setDataSale([]);
                        setModalState((prev: any) => ({
                            ...prev,
                            isAddModeOfSaleClicked: false,
                        }));
                        setIsEdited(false);
                        clearMultiCustomSelectionData();
                        clearData();
                        setInputSaleMode(false);
                        setDataIsUpdated(true);
                    }
                }}
            />
        </React.Fragment>
    );
}

export function SalesModeSelect({
    salesMode,
    formState,
    setFormState,
    inputSaleMode,
    isNameExist,
    dataSale,
    setIsEdited,
    setInputSaleMode,
    setIsNameExist,
    setSelectName,
    updateSalesSupportData,
}: any) {
    return (
        <div className="av-group">
            <label htmlFor="text" className="required__clz mt-3">
                {t("Sales method")}
            </label>
            <StyledSelectInput
                options={salesMode}
                placeholder={t("Select")}
                className={classnames("mdv_inp_FRmodeOfSale", {
                    invalid__clz: inputSaleMode || isNameExist,
                    "not-allowed-input__clz": dataSale.Id !== undefined,
                })}
                value={
                    formState.saleMode === ""
                        ? null
                        : {
                              label: formState.saleMode,
                              value: formState.saleMode,
                          }
                }
                onChange={(e: any) => {
                    const newSaleMode = e === null ? "" : e.label.trim();
                    setFormState((prev: any) => ({
                        ...prev,
                        saleMode: newSaleMode,
                    }));
                    setIsEdited(true);
                    setInputSaleMode(false);
                    setIsNameExist(false);
                    setSelectName(false);

                    updateSalesSupportData(newSaleMode);

                    if (
                        (e === null || e === undefined) &&
                        formState.displayName === ""
                    ) {
                        setFormState((prev: any) => ({
                            ...prev,
                            advancedDisplayName: {
                                languages: {
                                    fr: "",
                                    en: "",
                                    nl: "",
                                    es: "",
                                    pt: "",
                                    it: "",
                                },
                            },
                        }));
                    } else if (
                        e !== null &&
                        translatedSaleMethod[e.label] !== undefined
                    ) {
                        setFormState((prev: any) => ({
                            ...prev,
                            advancedDisplayName: {
                                languages: translatedSaleMethod[e.label.trim()],
                            },
                        }));
                    }
                }}
                isClearable
                noOptionsMessage={() => t("No options")}
                formatCreateLabel={formatCreateLabelModeOfSale}
                autoFocus={dataSale.Id === undefined}
            />
            {inputSaleMode && (
                <div
                    style={{
                        width: "100%",
                        marginTop: "0.25rem",
                        fontSize: "80%",
                        color: "#f46a6a",
                    }}
                >
                    {t("Please select a sales method")}
                </div>
            )}
            {isNameExist && (
                <div
                    style={{
                        width: "100%",
                        marginTop: "0.25rem",
                        fontSize: "80%",
                        color: "#f46a6a",
                    }}
                >
                    {t("This sales method already exists")}
                </div>
            )}
        </div>
    );
}

export function DisplayNameInput({
    formState,
    setFormState,
    selectName,
    setIsEdited,
    setSelectName,
    selectedLanguage,
    t,
    i18nextLng,
    setIsAdvancedDisplayNameModalOpen,
    isAdvancedDisplayNameModalOpen,
}: any) {
    return (
        <div className="av-group">
            <div className="d-flex justify-content-between mb-1">
                <label htmlFor="text" className="required__clz mt-3">
                    {t("Display name")}
                </label>
                <span
                    style={{
                        color: "blue",
                        cursor: "pointer",
                        border: "transparent",
                        backgroundColor: "transparent",
                        textAlign: "center",
                        textDecoration: "underline",
                        font: "normal normal 600 16px/21px Segoe UI",
                        marginTop: "15px",
                    }}
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                        setIsAdvancedDisplayNameModalOpen(
                            !isAdvancedDisplayNameModalOpen
                        )
                    }
                    className={classnames("cmn_btn_advencedDisplayName", {
                        "not-allowed-icon__clz":
                            formState.advancedDisplayName.languages[
                                i18nextLng
                            ] === "" && formState.saleMode === "",
                    })}
                >
                    <span>{t("Advanced")}</span>
                </span>
            </div>
            <StyledTextInput
                className={classnames("mdv_inp_FRdisplayName", {
                    input__clz: selectName,
                })}
                autoComplete="off"
                name="designation"
                onChange={(e: any) => {
                    setFormState((prev: any) => ({
                        ...prev,
                        displayName: e.target.value,
                        advancedDisplayName: {
                            ...prev.advancedDisplayName,
                            languages: {
                                ...prev.advancedDisplayName.languages,
                                [selectedLanguage.value]: e.target.value,
                            },
                        },
                    }));
                    setIsEdited(true);
                    setSelectName(false);
                    if (formState.saleMode === "" && e.target.value === "") {
                        setFormState((prev: any) => ({
                            ...prev,
                            advancedDisplayName: {
                                languages: {
                                    fr: "",
                                    en: "",
                                    nl: "",
                                    es: "",
                                    pt: "",
                                    it: "",
                                },
                            },
                        }));
                    }
                }}
                value={
                    formState.advancedDisplayName.languages[i18nextLng] ?? ""
                }
                placeholder={t("Write")}
                type="text"
            />
            {selectName && (
                <div
                    style={{
                        width: "100%",
                        marginTop: "0.25rem",
                        fontSize: "80%",
                        color: "#f46a6a",
                    }}
                >
                    {t("Please enter a display name")}
                </div>
            )}
        </div>
    );
}

export function SalesSupportSelect({
    salesSupport,
    setSalesSupport,
    salesSupportData,
    setIsEdited,
    selectSales,
    formState,
    isNameExist,
    t,
    saleSupportUsed,
    isModeOfSaleActiveInTemplate,
    isDeliverooAvaible,
    setSelectSales,
}: any) {
    return (
        <div className="av-group">
            <label htmlFor="text" className="required__clz mt-3">
                {t("Sales support")}
            </label>
            <MultiCustomSelect
                onDelete={() => setIsEdited(true)}
                result={[...new Set(salesSupport)]}
                setResult={setSalesSupport}
                data={salesSupportData}
                onChange={() => {
                    setIsEdited(true);
                    setSelectSales(false);
                }}
                className={classnames("mdv_inp_FRsalesSupport", {
                    invalid__clz: selectSales,
                    "not-allowed-input__clz":
                        formState.saleMode === "" ||
                        formState.saleMode === null ||
                        isNameExist,
                })}
                placeholder={`${t("Select")}`}
                value={t("Choose")}
                name="sales support"
                usedSaleSupports={saleSupportUsed}
                isModeOfSaleActiveInTemplate={isModeOfSaleActiveInTemplate}
                isDeliverooAvaible={isDeliverooAvaible}
            />
            {selectSales && (
                <div
                    style={{
                        width: "100%",
                        marginTop: "0.25rem",
                        fontSize: "80%",
                        color: "#f46a6a",
                    }}
                >
                    {t("Please select a sales support")}
                </div>
            )}
        </div>
    );
}

export function TagsInput({
    tagsData,
    setTagsData,
    tags,
    setIsEdited,
    t,
    formatCreateLabel,
}: any) {
    return (
        <div className="av-group">
            <label htmlFor="text" className="mt-3">
                {t("Tag")}
            </label>
            <MultiCustomCreatableSelection
                onDelete={() => setIsEdited(true)}
                isSendingTag={false}
                setResult={setTagsData}
                result={tagsData}
                data={tags}
                onChange={() => setIsEdited(true)}
                onCreateOption={() => setIsEdited(true)}
                placeholder={`${t("Select")}`}
                value={t("Choose")}
                name="tag"
                noOptionsMessage={() => t("No options")}
                formatCreateLabel={formatCreateLabel}
                max-width="100%"
                className="mdv_inp_FRtags"
            />
        </div>
    );
}

export function FormFooter({
    isEdited,
    isConsult,
    isActionsClicked,
    setIsEdited,
    setIsConsult,
    setActions,
    setModalState,
    setDataSale,
    setDataIsUpdated,
    clearData,
    clearMultiCustomSelectionData,
    setIsActionsClicked,
    handleValidateButtonOnClickEvent,
    setSalesSupport,
}: any) {
    const { t } = useTranslation();
    const handleCancel = () => {
        if (isEdited) {
            setActions(() => {
                setModalState((prev: any) => ({
                    ...prev,
                    isAddModeOfSaleClicked: false,
                }));
                setDataSale([]);
                setSalesSupport([]);
                setIsEdited(false);
                setDataIsUpdated(true);
                clearData();
                clearMultiCustomSelectionData();
            });
            setIsActionsClicked(!isActionsClicked);
        } else {
            setModalState((prev: any) => ({
                ...prev,
                isAddModeOfSaleClicked: false,
            }));
            setDataSale([]);
            setSalesSupport([]);
            setIsEdited(false);
            setDataIsUpdated(true);
            clearData();
            clearMultiCustomSelectionData();
        }
        setIsConsult(false);
    };

    return (
        <CustomCardFooter className="pt-1 pb-2">
            <CustomSecondaryColorButton
                outline
                rounded
                className="mr-2 mdv_btn_FRcancel cmn_btn_cancel"
                variant="light"
                onClick={handleCancel}
            >
                <span>{t("Cancel")}</span>
            </CustomSecondaryColorButton>

            <CustomMainColorButton
                rounded
                variant="primary"
                className={classnames("mdv_btn_FRvalidate cmn_btn_validate", {
                    "not-allowed-input-vr__clz": isConsult,
                })}
                onClick={handleValidateButtonOnClickEvent}
            >
                {t("Validate")}
            </CustomMainColorButton>
        </CustomCardFooter>
    );
}
